// src/runtime/KnowledgeEvolutionRuntime/runtime.ts
// ============================================
// KnowledgeEvolutionRuntime - IRuntime 实现（第十一个 Runtime）
//
// 特点：
//   - 后台运行，不占用 Workspace（白皮书：知识演化 Runtime 不占用 Workspace）
//   - 每天 23:00 由 SchedulerRuntime 调度 run_daily_evolution
//   - 查询：候选知识列表 / 统计 / 日报
//   - 命令：run_daily_evolution / extract_now / confirm_candidate / reject_candidate
// ============================================

import { RuntimeName } from '../../types/runtime';
import type {
  IRuntime,
  RuntimeStatus,
  RuntimeInfo,
  RuntimeEvent,
} from '../../types/runtime';
import { KnowledgeEvolutionService } from './service';
import { KnowledgeEvolutionQuery, KnowledgeEvolutionCommand } from './types';
import config from './config';

export class KnowledgeEvolutionRuntime implements IRuntime {
  readonly name = RuntimeName.KnowledgeEvolution;
  status: RuntimeStatus = 'idle';
  private service: KnowledgeEvolutionService;
  private startTime: number = Date.now();

  constructor(runtimeManager: any = null) {
    this.service = new KnowledgeEvolutionService(runtimeManager, console);
  }

  async initialize(): Promise<void> {
    this.status = 'loading';
    await this.service.initialize();
    this.status = 'ready';
    console.log('[KnowledgeEvolutionRuntime] ✅ Initialized（后台运行，不占用 Workspace）');
  }

  async destroy?(): Promise<void> {
    this.status = 'stopped';
    console.log('[KnowledgeEvolutionRuntime] Destroyed');
  }

  async query<T>(params?: unknown): Promise<T> {
    const { type, ...rest } = params as {
      type: KnowledgeEvolutionQuery;
      [key: string]: any;
    };
    const result = await this.service.query(type, rest);
    return result as unknown as T;
  }

  async execute<T>(command: string, params?: unknown): Promise<T> {
    const result = await this.service.execute(
      command as KnowledgeEvolutionCommand,
      (params as Record<string, any>) || {}
    );
    return result as unknown as T;
  }

  getInfo(): RuntimeInfo {
    return {
      name: this.name,
      version: config.version,
      status: this.status,
      health: this.status === 'ready' ? 'healthy' : 'unknown',
      description: config.description,
      uptime: Math.floor((Date.now() - this.startTime) / 1000),
    };
  }

  /** 事件订阅（预留扩展点） */
  on?(_event: RuntimeEvent, _callback: (payload: any) => void): void {
    // 预留
  }
}

export default KnowledgeEvolutionRuntime;
